import React, {Component} from 'react'
import Home from 'page/home'
import Login from 'page/login'
import Daftar from 'page/daftar'
import KodeReferal from 'page/kode_referal'
import Referral from 'components/users/referral'
import Point from 'components/users/point'
import Dashboard from 'page/dashboard'
import TokoReseller from 'page/berberkah/toko_reseller'
import Berberkah from 'page/berberkah/berberkah'
import DetilsProduct from 'page/product_detiles'
import User from 'page/user'
import CartPage from 'page/cart_page'
import Brand from 'page/brand'
import BrandPage from 'page/brand_page'
import Notifikasi from 'page/notifikasi'
import Product from 'page/product'
import Transaksi from 'page/transaksi'
import TransaksiBer from 'components/transaksi/breberkah'
import UploadPembayaran from 'components/transaksi/components/uploadpembayaran'
import Checkout from 'page/checkout'
import Statistik from 'page/statistik'
import Rekening from 'components/rekening/index'
import Riwayat from 'components/riwayat/riwayat'
import LoginBer from 'components/loginber/index'
import CategoryBer from 'page/berberkah/category'
import BerDetils from 'page/berberkah/ber_detils'
import BerProduct from 'page/berberkah/ber_product'
import BerCartPage from 'page/berberkah/ber_cart_page'
import BerAkun from 'page/berberkah/ber_akun'
import BerAccount from 'components/akun_berberkah/akun'
import BerTransaksi from 'components/akun_berberkah/main'
import BerAlamat from 'components/akun_berberkah/alamat'
import Test from 'page/login'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'

class App extends Component {
  render() {
      return (
        <Router>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route  path="/login" component={Login} />
            <Route  path="/daftar" component={Daftar} />
            <Route  path="/kode_referal" component={KodeReferal} />
            <Route  path="/dashboard" component={Dashboard} />
            <Route  path="/toko_reseller" component={TokoReseller} />
            <Route  path="/berberkah" component={Berberkah} />
            <Route  path="/detils_product" component={DetilsProduct} />
            <Route  path="/profile" component={User} />
            <Route  path="/referral" component={Referral} />
            <Route  path="/point" component={Point} />
            <Route  path="/cart_page" component={CartPage} />
            <Route  path="/brand" component={Brand} />
            <Route  path="/brand_page" component={BrandPage} />
            <Route  path="/notifikasi" component={Notifikasi} />
            <Route  path="/product" component={Product} />
            <Route  path="/transaksi" component={Transaksi} />
            <Route  path="/transaksi_ber" component={TransaksiBer} />
            <Route  path="/upload_bayar" component={UploadPembayaran} />
            <Route  path="/checkout" component={Checkout} />
            <Route  path="/statistik" component={Statistik} />
            <Route  path="/rekening" component={Rekening} />
            <Route  path="/riwayat" component={Riwayat} />
            <Route  path="/loginber" component={LoginBer} />
            <Route  path="/categoryber" component={CategoryBer} />
            <Route  path="/ber_detils" component={BerDetils} />
            <Route  path="/ber_product" component={BerProduct} />
            <Route  path="/ber_cart_page" component={BerCartPage} />
            <Route  path="/ber_akun" component={BerAkun} />
            <Route  path="/ber_account" component={BerAccount} />
            <Route  path="/ber_transaksi" component={BerTransaksi} />
            <Route  path="/ber_alamat" component={BerAlamat} />
            <Route  path="/test" component={Test} />
          </Switch>
        </Router>
      );
    }
  }

export default App;
